class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();

    console.log(this);
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (
      !openDetailsElement ||
      openDetailsElement.getAttribute("disabled") !== null
    )
      return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.querySelector(".shopify-section.section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset,
      )}px`,
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class GaiaHeader extends HTMLElement {
  constructor() {
    super();

    let gaiaHeader = this;

    window.addEventListener("scroll", () => {
      let headerRect = gaiaHeader.getBoundingClientRect();
      let headerPos = 0;
      if (window.scrollY > this.previousScroll) {
        // scrolling down
        headerPos = 0 - headerRect.height;
      } else {
        // scrolling up
      }
      this.style.top = `${headerPos}px`;
      this.previousScroll = window.scrollY;
    });

    this.addEventListener("click", () => {
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.getBoundingClientRect().bottom)}px`,
      );
    });
  }
}

customElements.define("gaia-header", GaiaHeader);

class GaiaMobileMenu extends GaiaDropdown {
  constructor() {
    super();
    // Add event listeners to all .menu-close elements within this menu
    this.querySelectorAll(".menu-close").forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        this.close();
      });
    });

    // --- Start mobile menu drilldown logic ---
    let mobileMenuCurrentLevel = "0";
    let mobileMenuCurrentParent = null;

    // Mobile menu tiers
    const setupMobileMenuDrilldown = () => {
      const menuRoot = document.getElementById("mobile-menu-drilldown");
      if (!menuRoot) return;
      if (window.innerWidth >= 1299) return;

      // Try to restore previous state (Accessibility)
      let selector = `.mobile-menu-view[data-level="${mobileMenuCurrentLevel}"]`;
      if (mobileMenuCurrentParent)
        selector += `[data-parent="${mobileMenuCurrentParent}"]`;
      let viewToShow =
        menuRoot.querySelector(selector) ||
        menuRoot.querySelector('.mobile-menu-view[data-level="0"]');

      // Add classes to set initial state
      menuRoot.querySelectorAll(".mobile-menu-view").forEach((view) => {
        if (view.getAttribute("data-level") === "0") {
          view.style.transform = "translateX(0)";
          view.classList.remove("inactive-menu");
          view.classList.add("active-menu");
        } else {
          view.style.transform = "translateX(100%)";
          view.classList.remove("active-menu");
          view.classList.add("inactive-menu");
        }
      });

      let currentView = viewToShow;

      // Update classes for all views
      function updateMenuViewClasses(activeView) {
        // Always keep first level (data-level=0) active-menu
        // Always keep activeView and its direct parent active-menu so they can stack
        const parentId = activeView.getAttribute("data-parent");
        let parentView = null;
        if (parentId) {
          parentView = menuRoot.querySelector(
            `.mobile-menu-view[data-index="${parentId}"]`,
          );
        }
        menuRoot.querySelectorAll(".mobile-menu-view").forEach((view) => {
          const isRoot = view.getAttribute("data-level") === "0";
          if (view === activeView || view === parentView || isRoot) {
            // Instantly remove inactive-menu, add active-menu
            view.classList.remove("inactive-menu");
            view.classList.add("active-menu");
            // If there was a pending timeout to add inactive-menu, clear it
            if (view._offCanvasTimeout) {
              clearTimeout(view._offCanvasTimeout);
              view._offCanvasTimeout = null;
            }
          } else {
            // Remove active-menu immediately, but delay adding inactive-menu for animation
            view.classList.remove("active-menu");
            if (view._offCanvasTimeout) {
              clearTimeout(view._offCanvasTimeout);
            }
            view._offCanvasTimeout = setTimeout(() => {
              view.classList.add("inactive-menu");
              view._offCanvasTimeout = null;
            }, 300);
          }
        });
      }

      menuRoot.addEventListener("click", function (e) {
        const nextBtn = e.target.closest("button.mobile-menu-next");
        const backBtn = e.target.closest("button.mobile-menu-back");

        if (nextBtn) {
          const index = nextBtn.getAttribute("data-index");
          // Parent stays, next slides in on top (from right)
          const nextView = menuRoot.querySelector(
            `.mobile-menu-view[data-parent="${index}"]`,
          );
          if (nextView) {
            nextView.style.transform = "translateX(0)";
            updateMenuViewClasses(nextView);
            // Don't hide parent, just let nextView cover it
            currentView = nextView;
            // Store state
            mobileMenuCurrentLevel = nextView.getAttribute("data-level");
            mobileMenuCurrentParent = nextView.getAttribute("data-parent");
          }
        }
        if (backBtn) {
          const parentLevel =
            parseInt(currentView.getAttribute("data-level")) - 1;
          let parentView;
          if (parentLevel === 0) {
            parentView = menuRoot.querySelector(
              '.mobile-menu-view[data-level="0"]',
            );
          } else {
            const parentIndex = currentView
              .getAttribute("data-parent")
              .split("-")[0];
            parentView = menuRoot.querySelector(
              `.mobile-menu-view[data-level="${parentLevel}"][data-parent="${parentIndex}"]`,
            );
          }
          if (parentView) {
            // Animate current out to left, parent slides in from right
            if (
              currentView.getAttribute("data-level") === "2" ||
              currentView.getAttribute("data-level") === "1"
            ) {
              currentView.classList.add("animating-out");
              currentView.style.transform = "translateX(100%)";
              parentView.style.transform = "translateX(0)";
              updateMenuViewClasses(parentView);

              // Wait for transition to finish before lowering zIndex
              const onTransitionEnd = (ev) => {
                if (ev.propertyName === "transform") {
                  currentView.classList.remove("animating-out");
                  currentView.removeEventListener(
                    "transitionend",
                    onTransitionEnd,
                  );
                }
              };
              currentView.addEventListener("transitionend", onTransitionEnd);
              currentView = parentView;
              // Store state
              mobileMenuCurrentLevel = parentView.getAttribute("data-level");
              mobileMenuCurrentParent = parentView.getAttribute("data-parent");
            } else {
              currentView.style.transform = "translateX(100%)";
              parentView.style.transform = "translateX(0)";
              updateMenuViewClasses(parentView);
              currentView = parentView;
              mobileMenuCurrentLevel = parentView.getAttribute("data-level");
              mobileMenuCurrentParent = parentView.getAttribute("data-parent");
            }
          }
        }
      });
    };

    // Run on load and on resize
    window.addEventListener("DOMContentLoaded", setupMobileMenuDrilldown);
    window.addEventListener("resize", setupMobileMenuDrilldown);
    setupMobileMenuDrilldown();
    // --- End mobile menu drilldown logic ---

    // --- Exclusive accordion: close others when one opens ---
    this.addEventListener("click", (e) => {
      const summary = e.target.closest(".mobile-accordion > summary");
      if (!summary) return;
      const accordion = summary.closest(".mobile-accordion");
      const levelView = accordion.closest(".mobile-menu-view[data-level='1']");
      if (!levelView) return;
      setTimeout(() => {
        if (accordion.open) {
          levelView.querySelectorAll(".mobile-accordion[open]").forEach((d) => {
            if (d !== accordion) d.removeAttribute("open");
          });
        }
      }, 0);
    });
    // --- End exclusive accordion ---
  }

  updateAriaLabel() {
    const detailsElement = this.querySelector("details");
    if (detailsElement) {
      if (detailsElement.hasAttribute("open")) {
        detailsElement.setAttribute("aria-label", "Close Main Menu");
      } else {
        detailsElement.setAttribute("aria-label", "Open Main Menu");
      }
    }
  }

  close() {
    if (window.matchMedia("(min-width: 1300px)").matches) {
      return;
    }

    this.details.classList.remove("open");
    this.details.classList.remove("opening");
    this.details.classList.add("closing");
    if (!this.closest("details")) {
    }
    document.body.classList.remove("overflow-hidden");
    document.body.classList.remove("menu-open");
    setTimeout(() => {}, 300);
    document.removeEventListener("click", this.clickOffListener);
    setTimeout(() => {}, 300); //Delay to allow attributes to be updated
  }

  close() {
    super.close();
    setTimeout(() => {
      this.updateAriaLabel();
    }, 300); //Delay to allow attributes to be updated
  }
}

customElements.define("gaia-mobile-menu", GaiaMobileMenu);

// This script watches the select elements for changes and updates the view to the correct localisation settings when changed.

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.forms = this.querySelectorAll("form");
    this.selects = this.querySelectorAll("select");
    this.inputs = this.querySelectorAll(
      'input[name="language_code"], input[name="country_code"]',
    );

    // Make the full pill clickable by forwarding wrapper clicks to the select
    this.querySelectorAll(".localisation-select-wrapper").forEach((wrapper) => {
      wrapper.addEventListener("click", (e) => {
        if (e.target.tagName !== "SELECT") {
          const select = wrapper.querySelector("select");
          if (select) {
            try {
              select.showPicker();
            } catch {
              select.focus();
            }
          }
        }
      });
    });

    // Add event listeners for all select elements
    this.selects.forEach((select) => {
      select.addEventListener("change", (event) => {
        // Check if the selected option has a redirect URL
        const selectedOption = select.options[select.selectedIndex];
        const redirect = selectedOption.getAttribute("data-redirect");
        if (redirect) {
          window.location.href = redirect;
          return;
        }

        // Update the corresponding hidden input if present
        const name = select.getAttribute("name");
        const value = select.value;
        this.inputs.forEach((input) => {
          if (input.getAttribute("name") === name) {
            input.value = value;
          }
        });
        // Submit the parent form
        const form = select.closest("form");
        if (form) {
          form.submit();
        }
      });
    });
  }
}

customElements.define("localization-form", LocalizationForm);
